// ============================================================================
// BOOKING ENDPOINTS
// ============================================================================
// API endpoint definitions for Booking module

import { buildEndpoint } from './base.endpoints';
import type { ID } from '../types/common.types';

const BASE_PATH = '/Booking';

export const bookingEndpoints = {
  /** GET /Booking — list all (paginated) */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /Booking/{id} — get by ID */
  getById: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** GET /Booking/{id}/full — get full booking with details and guests */
  getFullBooking: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/full`),

  /** POST /Booking — create */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /Booking/{id} — update */
  update: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),
  /** PUT /api/v1/Booking/{id}/rate-worksheet — surgical rate re-pricing (in-house/departed capable). */
  rateWorksheet: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/rate-worksheet`),
  /** PUT /api/v1/Booking/{id}/source — surgical source/channel correction. */
  changeSource: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/source`),
  /** PUT /api/v1/Booking/{id}/settlement — in-house "Change settlement" (PMS slice 3b). */
  changeSettlement: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/settlement`),
  /** GET /Booking/{id}/confirmation-pdf — download confirmation PDF */
  confirmationPdf: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/confirmation-pdf`),

  /** POST /Booking/{id}/block — transition TENTATIVE → BLOCKED with expires_at */
  block: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/block`),

  /** PATCH /Booking/{id}/block/expiry — update expires_at on a BLOCKED booking */
  updateBlockExpiry: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/block/expiry`),

  /** POST /Booking/{id}/block/extend — one-click +extension_hours extension */
  extendBlock: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/block/extend`),

  /** POST /Booking/{id}/block/confirm — manual confirm of a BLOCKED booking */
  confirmBlocked: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/block/confirm`),

  /** POST /Booking/{id}/request-due-date-extension — cashier-initiated extension */
  requestDueDateExtension: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}/request-due-date-extension`),

  /**
   * GET /Booking/day-guest-list — who is arriving / staying over / departing
   * on one date. A stay-span overlap query, NOT the list filtered by date.
   */
  dayGuestList: () => buildEndpoint(`${BASE_PATH}/day-guest-list`),

  /** DELETE /Booking/{id} — delete */
  delete: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),
};

export default bookingEndpoints;
